module.exports = __webpack_public_path__ + "img/error.4a9d744d.png";